import {observer} from "mobx-react";
import React, {useEffect, useState} from "react";
import store from "./store";
import Spacer from "../../components/Spacer";
import {Alert, Button, Form, Input, Menu, Modal, notification, Popconfirm, Select, Space, Spin} from "antd";
import Switcher, {Showable, Switch2} from "../../components/Switcher";
import axios from "axios";
import {callAndReload, callWithCatch, pp, tourneyUrl} from "../../utils";
import FakeTable from "../../components/FakeTable";
import {observable} from "mobx";
import PopupMenu from "../../components/PopupMenu";
import FormSelector from "../../components/FormSelector";
import {FormModalBtn, NiceModalForm} from "../../components/Modals";
import User from "../../components/User";
import {PlayerStore} from "../rt/PlayerDrawer";
import Tourney from "./Tourney";
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {useForm} from "antd/es/form/Form";
import _ from "lodash";
import WavierCheck from "./WavierCheck";
import TShirtSelector from "@/components/TShirtSelector.js";

// rating: { mixed: [3.4, "self"], etc }
export const RegStore = observable({
  saving: false,
  division: null,
  event: null,
  isSingles: false,
  editSource: 'self',
  editRating: null,
  hadRating: false,
  isOpenDivision: false,
  type: null,
  rating: gon.rating || {},
  ratingFor: type => {
    return RegStore.rating[type]
  },
  isValid: () => {
    if (!RegStore.editRating.match(/^\d\.\d\d?$/))
      return false;

    let rating = parseFloat(RegStore.editRating);

    return rating >= 2 && rating <= 5
  },
  save: async () => {
    RegStore.saving = true;
    let rating = parseFloat(RegStore.editRating);
    let type = RegStore.type;

    let params = {
      type,
      source: RegStore.editSource,
      rating
    };

    let data = (await axios.post(`/tournaments/${gon.tournament.tid}/rating`, params)).data;

    RegStore.rating = data.rating;
    RegStore.saving = false;
  },
  close: () => RegStore.division = null
});

export const RatingForm = observer(({}) => {
  const [form] = Form.useForm();
  let type = RegStore.type;

  return <div>
    <div>What is your highest <b>{_.startCase(type)}</b> rating?</div>
    <div className="text-slate-500 text-sm">Self rate if you dont have any official rating</div>
    <br/>
    <Form labelCol={{span: 6}} form={form} initialValues={{rating_source: RegStore.editSource, rating: RegStore.editRating}}>
      <Form.Item name='rating' label="Your Rating" rules={[{ required: true, pattern: /^[2345]\.\d{1,3}$/, message: "2.0-5.999" }]}>
        <Input autoFocus style={{width: "65px"}} onChange={e => RegStore.editRating = e.target.value} />
      </Form.Item>
    </Form>
  </div>
});

export const FreeReg = NiceModal.create(({ d }) => {
  let onSave = async (params) => {
    await callWithCatch({
      url: `/tournaments/${gon.tournament.tid}/individual_reg`,
      params: { ...params, division_id: d.id },
      method: 'post',
      reload: true
    })
  }

  return <NiceModalForm top={20} topOnMobile width={300} okBtnInFooter onSave={onSave} title={"Complete Registration"} initialValues={{}} okText="Register">
    <Form.Item label="Player" rules={[{ required: true}]}>
      <Input disabled={true} value={gon.user.name}/>
    </Form.Item>
    <Form.Item name="code" label="Code" rules={[{required: true, message: "Required"}]}>
      <Input autoFocus />
    </Form.Item>
    <Alert message="You'll be able to select your partner after both of you are registered" />
    {/*<WavierCheck />*/}
  </NiceModalForm>;
});


export const LvmpdReg = NiceModal.create(({ pl }) => {
  const modal = useModal();
  const [form] = useForm();

  let onSave = async (params) => {
    await callWithCatch({
      url: `/tournaments/${gon.tournament.tid}/individual_reg`,
      params,
      method: 'post',
      reload: true
    })
  }

  let divs = _.filter(gon.tevents[0].divisions, d => !d.reg_closed).map(d => ({ value: d.id, label: d.name })) ;

  return <NiceModalForm top={20} form={form} topOnMobile width={300} okBtnInFooter onSave={onSave} modal={modal} title={"Complete Registration"} initialValues={{}} okText="Register">
    <Form.Item label="Player" rules={[{ required: true}]}>
      <Input disabled={true} value={gon.user.name}/>
    </Form.Item>
    {/*<Form.Item name="tshirt_size" label="T-Shirt Size" rules={[{required: true}]}>*/}
    {/*  <TShirtSelector />*/}
    {/*</Form.Item>*/}
    <Form.Item name="xid" label="SPA p#" rules={[{required: true, message: "Required"}]} extra="Member of the SPA of the teamd">
      <Input autoFocus />
    </Form.Item>
    <Form.Item name="division_id" label="Division" rules={[{required: true}]}>
      <Select style={{width: "100%"}} options={divs}/>
    </Form.Item>
    <Alert message="You'll be able to select your partner after both of you are registered" />
    <WavierCheck />
  </NiceModalForm>;
});

export const PlayerUnWithdrawer = observer(({r, juniors, asMenu, ...props}) => {
  let withdraw = () => {
    callWithCatch({
      url: `/registrations/${r.id}`,
      method: 'put',
      params: { unwithdraw: true },
      onSuccess: () => {
        PlayerStore.reload();
        store.triggerRefresh('reg_change');
      }
    })
  }

  let btn = <Button type="link">Re-Register</Button>;
  if (asMenu)
    btn = <Menu.Item>Re-Register</Menu.Item>

  return <Popconfirm
    title="Re-Register to the event?"
    onConfirm={withdraw}
  >
    {btn}
  </Popconfirm>
});

export const PlayerWithdrawer = observer(({r, asMenu, ...props}) => {
  let withdraw = () => {
    if (User.admin)
      callWithCatch({
        url: `/registrations/${r.id}`,
        method: 'put',
        params: { withdraw: true },
        onSuccess: () => {
          PlayerStore.reload();
          store.triggerRefresh('reg_change');
        }
      })
    else
      callAndReload({
        url: `/registrations/${r.id}`,
        method: 'put',
        params: { withdraw: true },
      })
  }

  let btn = <Button type="link">Withdraw</Button>;
  if (asMenu)
    btn = <Menu.Item>Withdraw</Menu.Item>

  return <Popconfirm
    title="Withdraw from event?"
    onConfirm={withdraw}
  >
    {btn}
  </Popconfirm>
})

export const PlayerChanger = NiceModal.create(observer(({r, juniors}) => {
  let [updating, setUpdating] = useState(false);
  let [player, setPlayer] = useState([]);
  let [teams, setTeams] = useState([]);
  let [teamType, setTeamType] = useState([]);

  useEffect(() => {
    let load = async () => {
      let data = (await axios.get(`/registrations/${r.id}/edit`)).data;

      setPlayer(data.player);
      setTeams(data.teams);
      setTeamType(data.team_type);
    };
    load();
  }, [r]);

  let update = (team) => {
    callWithCatch({
      setLoading: setUpdating,
      url: `/registrations/${r.id}`,
      method: 'put',
      params: { team },
      reload: !User.admin,
      onSuccess: () => {
        PlayerStore.reload();
        store.triggerRefresh('reg_change');
      }
    })
  }

  let isDoubles = teamType === "doubles";
  let isTeams4 = teamType === "teams4";
  let headerText;

  let needJoin = !r.team || r.alone || r.team?.players?.length === 1;

  if (needJoin)
    headerText = isDoubles ? "Change Partner" : "Join Team";
  else
    headerText = "Leave team";

  let playersChoice = () => {
    return <div className="overflow-y-auto" style={{maxHeight: "510px"}}>
      <FakeTable cs="ant-table-small" data={teams.map(t => [t.players.map(pl => pl.name).join(", "), <Button size="small" block onClick={() => update(t.id)} type="primary">Team with {t.players[0].name.split(/ /)[0]}</Button>])} />
    </div>
  }

  let inner;
  if (isTeams4) {
    inner = <Switch2 v={needJoin}>
      <div>
        { !teams.length && <Alert type="warning" message="No teams to join" /> }
        { !!teams.length && <Alert type="warning" message="Make sure they want to team with you before joining!" /> }
        <br/>
        <div className="font-bold">Select Team:</div>
        {playersChoice()}
      </div>
      <div>
        <Button className=" mb-4" onClick={() => update("remove")} type="danger">Leave Current Team</Button>
      </div>
    </Switch2>
  }
  else {
    inner = <div>
      <Showable v={!!teams?.length && !Tourney.no_reg}>
        <Alert type="warning" message="Make sure they want to partner together before partnering up!" />
        <br/>
        <div className="font-bold">Select Partner:</div>
      </Showable>
      { !teams?.length && <Alert type="warning" message="No players without a partner" /> }
      {playersChoice()}
      <Showable v={false}>
        <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mt-4" role="alert">
          <div>
            <div>Don't see the partner?</div>
            <div>Change status to "Has Partner" and tell them to register</div>
            <br/>
            <Button onClick={() => update("has")} type="primary" size="small" >Change status to "Has Partner"</Button>
          </div>
        </div>
        <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mt-4" role="alert">
          <div>
            <div>No partner?</div>
            <br/>
            <Button onClick={() => update("need")} size="small" type="primary">Change status to "Partner Needed"</Button>
          </div>
        </div>
      </Showable>
    </div>
  }

  return <NiceModalForm
                footer={null}
                top
                zIndex={1005}
                title={headerText + " for " + player.name}
                width={500}
  >
    <Spin spinning={updating}>
      {inner}
    </Spin>
  </NiceModalForm>
}));

export const PlayerChangerButton = observer(({r, asLink, asMenu, btnProps, children, juniors, ...props}) => {
  if (gon.tournament.status === "done")
    return null;

  let isDoubles = r.division_name?.match(/Doubles/);
  let needJoin = !r.team || r.alone || r.team?.players?.length === 1;
  
  let headerText;
  if (needJoin)
    headerText = isDoubles ? "Change Partner" : "Join Team";
  else
    headerText = "Leave team";

  const handleClick = () => {
    NiceModal.show(PlayerChanger, { r, juniors, ...props });
  };

  if (asMenu) 
    return <Menu.Item onClick={handleClick}>{children || headerText}</Menu.Item>;
  
  if (asLink) 
    return <a onClick={handleClick}>{children || headerText}</a>;
  
  return <Button onClick={handleClick} {...btnProps}>{children || headerText}</Button>;
});

export const CreateTeam = NiceModal.create(observer(({ r }) => {
  let onSave = async (params) => {
    await callWithCatch({
      url: tourneyUrl(`/t`),
      params: { ...params, registration_id: r.id, division_id: r.division_id },
      method: 'post',
      reload: true,
      keepLoading: true
    });
  }

  return <NiceModalForm width={250} onSave={onSave} title="Edit Team" okText="Save">
    <Form.Item label="Captain Name">
      <Input style={{width: "100%"}} value={gon.player.name} disabled/>
    </Form.Item>
    <Form.Item name="team_name" label="Team Name" rules={[{required: true, message: "Required"}]}>
      <Input style={{width: "100%"}} autoFocus placeholder="e.g. Super Dinkers"/>
    </Form.Item>
  </NiceModalForm>
}))

const TeamRegister = NiceModal.create(observer(({ d }) => {
  let onSave = async (params) => {
    let rParams = {
      type: 'doubles',
      source: 'self',
      rating: parseFloat(params.doubles_rating)
    };

    let data = await callWithCatch({
      url: `/tournaments/${gon.tournament.tid}/rating`,
      method: 'post',
      params: rParams,
      onSuccess: (data) => {
        RegStore.rating = data.rating;
      }
    })

    if (!data.err) {
      await callWithCatch({
        url: `/tournaments/${gon.tournament.tid}/register`,
        params: { division_id: d.id, team: 'create' },
        method: "post",
        onSuccess: data => {
          store.cart = data.cart;
        }
      })

      return true;
    }
  }

  let r = RegStore.ratingFor('doubles');
  let doubles_rating = r && r[0];

  return <NiceModalForm width={300} onSave={onSave} title={"Register to " + d.name} initialValues={{doubles_rating }} okText="Add to Cart">
    <Alert message="After payment you will be able to join find your team members to team up" />
    <br/>
    <Form.Item name='doubles_rating' label="What is your highest Doubles rating? (self rate if you dont have any official rating)" rules={[{ required: true, pattern: /^[2345]\.\d{1,3}$/, message: "2.0-5.999" }]} extra="">
      <Input autoFocus style={{width: "65px"}} />
    </Form.Item>
  </NiceModalForm>
}));

export default observer(({}) => {
  let [loading, setLoading] = useState();

  let step = RegStore.step;
  let division = RegStore.division;

  if (!division)
    return null;

  let pending = _.filter(division.teams, t => t.players.length === 1);
  let noPending = pending.length === 0;

  let close = () => {
    RegStore.division = null;
  }

  let register = (team) => {
    callWithCatch({
      setXhr: setLoading,
      url: `/tournaments/${gon.tournament.tid}/register`,
      params: { division_id: division.id, team },
      method: "post",
      onSuccess: data => {
        store.cart = data.cart;
        if (data.msg)
          notification.error({
            message: data.msg,
          });
        close();
      }
    })
  }

  let inner;
  let footer=null;

  if (step === "search") {
    let teams = _.filter(division.teams, t => t.players.length === 1);

    if (division.name.match(/Mixed/))
      teams = _.reject(teams, t => t.players[0].gender === gon.user.gender);

    inner = <div>
      <div className="font-bold">Select your partner to register:</div>
      <FakeTable data={teams.map(t => [t.players[0].name, <Button onClick={() => register(t.id)} type="primary">Register with {t.players[0].name.split(/ /)[0]}</Button>])} />
      { !teams.length && <Alert type="warning" message="no teams without a partner" /> }
      <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mt-8" role="alert">
        <Spacer>
          <div>
            { !!teams.length && <div>Don't see your partner?</div> }
            <div>Create your team, they will register with you.</div>
          </div>
          <Button onClick={() => register("create")} type="primary2">Create Our Team</Button>
        </Spacer>
      </div>
    </div>
    footer = <Spacer l={<Button onClick={() => RegStore.step = 'partnerQ'}>Back</Button>} />
  }

  if (step === "searchTeam") {
    let teams = _.filter(division.teams, t => t.players.length < 4);

    let data = teams.map(t => [
        t.players.map(pl => <div key={pl.id}>{pl.name}</div>),
        <Button onClick={() => register(t.id)} type="primary">Register with {t.players[0].name.split(/ /)[0]}</Button>
      ]);

    inner = <div className="space-y-4">
      <div className="font-bold">Select your team:</div>
      <FakeTable data={data} />
      { !teams.length && <Alert type="warning" message="no teams with open spots" /> }
      <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mt-8" role="alert">
        <div>
          <div>Don't see your team?</div>
          <div>Create your team, and tell your teammates to register with you.</div>
        </div>
        <br/>
        <Button onClick={() => register("create")} type="primary">Create Our Team</Button>
      </div>
    </div>
    footer = <Spacer l={<Button onClick={close}>Cancel</Button>} />
  }

  let isSingles = division.name.match(/Singles/);

  if (step === "rating") {
    let setRating = async () => {
      if (!RegStore.isValid()) {
        alert("please enter rating between 2.0-5.0");
        return;
      }

      await RegStore.save();

      if (parseFloat(RegStore.editRating) > division.player_rating_max) {
        alert(`${RegStore.editRating} not qualify for ${division.name}, please register to higher bracket`);
        RegStore.division = null;
        return;
      }

      if (isSingles)
        register('create');
      else
        RegStore.step = 'partnerQ';
    }

    footer = <Spacer>
      <Button onClick={close}>Cancel</Button>
      <Switcher switchTwo v={isSingles}>
        <Button type="primary" onClick={setRating}>Add To Cart</Button>
        <Button type="primary" onClick={setRating}>Next</Button>
      </Switcher>
    </Spacer>

    inner = <RatingForm isSingles={isSingles} division={division} />
  }

  let createTeam = () => {
    prompt("Please enter your team name");
  }

  if (step === 'directReg') {
    inner = "This is an open event, all players register regardless of age/skill";
    footer = <Spacer>
      <Button onClick={close}>Cancel</Button>
      <Button loading={loading} type="primary" onClick={() => register('create')}>Add To Cart</Button>
    </Spacer>
  }

  if (step === 'partnerQ') {
    let addTo = RegStore.event.team_type === "teams4" ? 'Team' : 'Partner';

    inner = <div>
      <Spacer direction="vertical">
        <div>Do you have a partner already?</div>
        <Space direction="vertical">
          <Switcher switchTwo v={noPending}>
            <Space>
              <Button onClick={() => register("create")} type="primary">Yes</Button>
              They'll join my team later
            </Space>
            <Space>
              <Button onClick={() => RegStore.step = 'search'} type="primary">Yes</Button>
              Find my {addTo}
            </Space>
          </Switcher>
          <Space>
            <Button onClick={() => register("need")}>No</Button>
            <div>Add me to {addTo} Needed list</div>
          </Space>
        </Space>
      </Spacer>
    </div>

    if (RegStore.hadRating || RegStore.isNoRating)
      footer = <Spacer l={<Button onClick={RegStore.close}>Cancel</Button>} r={null}/>
    else
      footer = <Spacer l={<Button onClick={() => RegStore.step = 'rating'}>Back</Button>} r={null}/>
  }

  return <div>
    <Modal title={division.name}
           visible={true}
           footer={footer}
           onCancel={close}>
      {inner}
    </Modal>
  </div>
});

export const HopTryoutsReg = NiceModal.create(() => {
  const modal = useModal();
  const [form] = useForm();
  const [availableDivisions, setAvailableDivisions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch available divisions from server
    const fetchDivisions = async () => {
      await callWithCatch({
        url: `/tournaments/${gon.tournament.tid}/individual_reg?get_divisions=true`,
        method: 'get',
        onSuccess: (data) => {
          let divs = _.sortBy(data.divisions, 'name') || []
          setAvailableDivisions(divs);
          form.setFieldsValue({division_id: divs[0].id})
          setLoading(false);
        },
        onError: () => {
          setAvailableDivisions([]);
          setLoading(false);
        }
      });
    };

    fetchDivisions();
  }, []);

  let onSave = async (params) => {
    await callWithCatch({
      url: `/tournaments/${gon.tournament.tid}/individual_reg`,
      params,
      method: 'post',
      reload: true
    })
  }

  let clubOptions = [
    { value: 'Armory', label: 'Armory' },
    { value: 'BPC', label: 'BPC' },
  ];

  return <NiceModalForm 
    top={20} 
    form={form} 
    topOnMobile 
    width={300}
    okBtnInFooter 
    onSave={onSave} 
    modal={modal} 
    title="Registration"
    initialValues={{}} 
    okText="Register"
  >
    <Form.Item label="Player" rules={[{ required: true}]}>
      <Input disabled={true} value={gon.user?.name}/>
    </Form.Item>

    <Form.Item name="club_membership" label="Club Membership" rules={[{required: true}]}>
      <Select style={{width: "100%"}} options={clubOptions} placeholder="Select your club"/>
    </Form.Item>

    <Form.Item name="tshirt_size" label="T-Shirt Size" rules={[{required: true}]}>
      <TShirtSelector />
    </Form.Item>

    <Form.Item name="division_id" label="Division" rules={[{required: true}]}>
      <FormSelector
        width="250px"
        options={availableDivisions.map(div => [div.id, div.name])}
        placeholder="Select division"
      />
    </Form.Item>

    {/*<WavierCheck />*/}
  </NiceModalForm>;
});

